import React from "react";
import { Star, Users, Clock, Book } from "lucide-react";
import { Link } from "react-router-dom";
import { formatDistanceToNow } from 'date-fns';


const CourseCard = ({ course }) => {
  return (
    <Link
      to={`/courses/${course._id}`}
      className="group relative bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow overflow-hidden flex flex-col"
    >
      <img
        src={course.image}
        alt={course.title}
        className="h-48 w-full object-cover transition-transform duration-300 group-hover:scale-105"
      />

      <div className="p-5 flex flex-col flex-grow">
        <h3 className="text-lg font-semibold text-gray-800 group-hover:text-indigo-600 line-clamp-2">
          {course.title}
        </h3>
        <p className="text-sm text-gray-500 mt-2 mb-4 line-clamp-3">
          {course.description}
        </p>

        <div className="flex justify-between text-xs text-gray-500 mb-4">
          {/* <div className="flex items-center gap-1">
            <Star className="w-4 h-4 text-yellow-400" />
            <span>{course.rating}</span>
          </div> */}
          <div className="flex items-center gap-1">
            <Users className="w-4 h-4" />
            <span>{course.students.length}</span>
          </div>
          <div className="flex items-center gap-1">
            <Clock className="w-4 h-4" />
            <span>{course.duration} hours</span>
          </div>
        </div>

        <div className="flex items-center justify-between mt-auto">
          <div className="flex items-center gap-2 text-indigo-600 font-semibold">
            <Book className="w-5 h-5" />
            <span>${course.price}</span>
          </div>
          <span className="text-sm text-indigo-500 font-medium group-hover:underline">
            View Details →
          </span>
        </div>
        <span className="text-sm text-gray-500 text-right mt-2">
    Posted {formatDistanceToNow(new Date(course.createdAt), { addSuffix: true })}
  </span>
      </div>
    </Link>
  );
};

export default CourseCard;
